import * as React from 'react';
import { Search } from 'lucide-react';
import { cn } from '../lib/utils';
import { Input } from '../primitives/input';

export interface FilterToolbarProps extends React.ComponentPropsWithoutRef<'div'> {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  filters?: React.ReactNode;
  viewSwitcher?: React.ReactNode;
  sortControl?: React.ReactNode;
  actions?: React.ReactNode;
}

export function FilterToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters,
  viewSwitcher,
  sortControl,
  actions,
  className,
  children,
  ...props
}: FilterToolbarProps) {
  return (
    <div
      className={cn(
        'py-1',
        className
      )}
      {...props}
    >
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex flex-wrap items-center gap-3">
          {viewSwitcher}
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="search"
              value={searchValue ?? ''}
              onChange={(e) => onSearchChange?.(e.target.value)}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder.replace(/[.…]+$/, '')}
              className="min-w-[200px] pl-9"
            />
          </div>
          {filters}
        </div>
        {(sortControl || actions) ? (
          <div className="ml-auto flex flex-wrap items-center gap-3">
            {sortControl}
            {actions}
          </div>
        ) : null}
      </div>
      {children}
    </div>
  );
}
